<template>
    <div class="newsbox">
        <!-- <div class="box_title">
            <div class="box_title_left">
                {{ name }}
            </div>
            <div class="box_title_right">
               <span class="el-icon-location-outline"></span> 当前位置:  <router-link to="/"> 首页 </router-link> /  {{ name }} 
            </div>
        </div> -->
        <!-- 新闻列表 -->
        <div class="news_list">
            <div class="news_item" v-for="(item, index) in NewsList" :key="index" @click="showInfo( item )"  @mouseover="hoverIndex = index" @mouseout="hoverIndex = null">
                <div class="img_content_box">
                    <div :class="hoverIndex == index ? 'hvr-grow' :''  ">
                        <img :src="item.img" v-if="item.img && item.img.indexOf('http') != -1" alt="">
                        <img :src="$ImgUrl + item.img" v-if="item.img && item.img.indexOf('http') == -1" alt="">
                        <img src="../../assets/static/index/left_nav_bg3.png" v-if="!item.img" alt="">
                    </div>
                </div>
                <div class="news_title" :class="hoverIndex == index ? 'activeItem' :''  ">
                    {{ item.title }}    
                </div>
                <div class="news_content">
                    <span>{{ item.content }}</span>
                </div>
                <div class="timeandread">
                    <div class="time">
                        <span class="iconfont icon-shijian"></span>
                        <span> {{ item.createTime }}</span>
                    </div>
                    <div class="reae">
                        <span class="el-icon-view"></span>
                        <span>浏览: {{ item.count }} 次</span>
                    </div>
                </div>
            </div>
            
        </div>

        <!-- 分页 -->
        <div class="page" style="text-align:center;" v-if="NewsList && NewsList.length">
            <el-pagination
            background
            layout="prev, pager, next"
            :current-page="pageNum"
            :pageSize="10"
            @current-change="pageChange"
            :total="10 * totalPage">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                name: "党建专题",
                pageNum: 1,
                NewsList: [],
                totalPage: 0,
                hoverIndex: null,
            }
        },
        created () {
            this.getNewsList()
        },
        methods: {
            async getNewsList() {
                this.NewsList = []
                let res = await this.$axios.post("/lencon/pc/news/srList", { pageNum: this.pageNum })
                if ( res.data.code == 1 ) {
                    this.NewsList = res.data.specialReportList
                }
            },
            pageChange ( page ) {
                this.pageNum = page 
                this.getNewsList()
            },
            // 展示专题详情
            showInfo ( item ) {
                this.$router.push(`/zhuanti/${ item.specialReportId }`)
            },
        },
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.activeItem {
    color: #fff;
    font-weight: bold;
    background-color: #2767c4  !important;
}
.newsbox {
    width: 1200px;
    margin: 40px  auto;
    padding: 30px 0;
    background-color: #fff;
    .box_title {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        border-left: 4px solid #fff;
        margin: 20px 0;
        .box_title_left {
            font-size: 24px;
            font-weight: bold;
        }
        .box_title_right {
            font-size: 14px;
        }
    }
    .news_list {
        width: 1200px;
        box-sizing: border-box;
        padding: 50px;
        background-color: #fff;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .news_item {
            width: 534px;
            margin-bottom: 40px;
            cursor: pointer;
            border: 1px solid #EEEEEE;
            .img_content_box {
                width: 534px;
                height: 246px;
                overflow: hidden;
                img {
                    width: 534px;
                    height: 246px;
                    display: block;
                }
            }
            .news_title {
                text-align: center;
                font-weight: bold;
                font-size: 18px;
                padding: 10px; 
                background: rgba(238, 238, 238, 0.59);
            }
            .news_content {
                padding: 10px;
                @include MultipleRows(2);
                color: #868281;
                font-size: 16px;
                span {
                    @include MultipleRows(2);
                }
            }
            .timeandread {
                font-size: 14px;
                color: #BEBEBE;
                display: flex;
                align-items: center;
                .time {
                    padding: 10px 20px 10px 10px;
                }
            }
        }
    }
}
</style>